import { v4 as uuidv4 } from "uuid";
export class PAWorkFlowModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.isArchived = false;
        this.workFlowSteps = [];
    }
}
export default class PAWorkFlow extends PAWorkFlowModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
